// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://hjyyrcngrejsdoizdtfd.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhqeXlyY25ncmVqc2RvaXpkdGZkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDEyOTI4MTAsImV4cCI6MjA1Njg2ODgxMH0.cQgr-FaOJ2riqWb5NZ0hOyzOL8c9cOXum9UxAvRNXW4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);